module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.dd4ff11.woff";